import nita from '../nit_logo.png';
import hcpgc from "../hcpgc.png";
import nielit from "../NIELIT.jpg";
import school from "../school.jpg";
const academicDetails = [
    {
        course: "M.C.A.",
        institute: "NIT Agartala",
        logo: nita,
        year: "2021 to Present",
        description: [
            "Passed 1st year with 9.04%",
            "Appearing 2nd year in 2022"
        ]
    },{
        course: "O Level",
        institute: "NIELIT",
        fullName: "Undergraduate Diploma of 1 year",
        logo: nielit,
        year: "2018 to 2020",
        description: [
            "Passed in 2020 with Grade A.",
            "Subject of Study: IT Tools, Web Design,ICT,C Lanuage",
            "Experties in : C Language."
        ]
    },
    {
        course: "B.Sc.(Maths)",
        institute: "HCPGC Varanasi",
        fullName: "Master of Computer Application",
        logo: hcpgc,
        year: "2018 to 2021",
        description: [
            "Passed in 2021 with 67%.",
            "Subject of Study: Physics, Maths, Chemistry.",
            "Experties in : Maths"
        ]
    },
    {
        course: "Intermediate",
        institute: "SKCAV IC",
        fullName: "U.P. Board",
        logo: school,
        year: "2015 to 2017",
        description: [
            "Passed in 2017 with 75.2%",
            "Mian Subject: Physics, Maths, Chemistry",
            "Experties in : Maths"
        ]
    },
    {
        course: "High School",
        institute: "SKCAV IC",
        fullName: "U.P. Board",
        logo: school,
        year: "2013 to 2015",
        description: [
            "Passed in 2017 with 75.2%",
            "Main Subject: Math , Science",
            "Experties in : Math"
        ]
    }
];

export default academicDetails;